import { UserListDTO } from '../user/user-list.dto';

export class TradeRequestEventParticipantsListDTO {

    type: number;

    start: string | Date;

    end: string | Date;

    user: UserListDTO;

}
